
import { Button, Container } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';


import api_url from '../../config/api_url';


const IngredientDisplay = (props) => {

    const [edit, setEdit] = useState(false);
    const [units, setUnits] = useState(props.obj.units);
    let nameJsx = <h3>{props.obj.name}</h3>

    useEffect(() => {
        if(!props.edit) {
            return;
        }

        if(props.obj.id === undefined) {
            console.log("err props obj is undefined still xdddd");
            console.log(props);

            return;
        }
        console.log("rec ing list");
        console.log(props);
        let isSubscribed = true;

        // declare the async data fetching function
        const fetchData = async () => {
          // get the data from the api
          
        
          const fetchUrl = api_url + "/api/recipes/ingredients/unit/" +  props.obj.id;
          const data = await fetch(fetchUrl);
          const json = await data.json();

          //const data = [{name: "abc", id: 1, price:"12dkk",}, {name: "efg", id: 2, price:"12dkk"}, {name:param, id: 3, price:"14dkk"} ]
          // convert the data to json
          //const json = await response.json();
        
          // set state with the result if `isSubscribed` is true
          if (isSubscribed) {
            setUnits(json);
          }
        }
      
        // call the function
        fetchData()
          // make sure to catch any error
          .catch(console.error);;
      
        // cancel any future `setData`
        return () => isSubscribed = false;
      }, [edit])

    const editIngredientName = (newVal) => {

        if(newVal==props.obj.name) {
            return;
        }
        let newObj = { ...props.obj };
        newObj.name = newVal;
        props.editFunction(props.index, newObj);
        setEdit(false);
    }

    const editIngredientPrice = (newVal) => {
        console.log("edit regu " + newVal);
        
        if(newVal==props.obj.price) {
            console.log("no change return");
            return;
        }
        let newObj = { ...props.obj };
        newObj.price = newVal;
        props.editFunction(props.index, newObj);
    }

    const editIngredientOrganicPrice = (newVal) => {
        console.log("edit organic " + newVal);
        if(newVal==props.obj.price_organic) {
            console.log("no change return");
            return;
        }
        let newObj = { ...props.obj };
        newObj.price_organic = newVal;
        props.editFunction(props.index, newObj);
    }

    const addNewUnit = () => {
        setUnits([...units, {name: ""}])
    }
    


    


    const deleteIngredient = () => {
        props.deleteFunction(props.index);
    }
    

    const handleEdit = () => {
        setEdit(prev=> !prev);
        console.log(props.obj);
    }


    return (
        <>
        <Container className="border mb-3">
            <Row className="">
                <Col xs={8}>
                    <NameComponent nameVal={props.obj.name} edit={edit} handleEdit={editIngredientName} />
                </Col>
                <Col xs={4}>
                    <Button onClick={handleEdit} value="Rediger">Rediger</Button>
                    <Button onClick={deleteIngredient} value="Slet ingrediens">Slet </Button>
                </Col>
            </Row>
            <PriceComponent edit={edit} price={props.obj.price} price_organic={props.obj.price_organic} handlePrice={editIngredientPrice} handleOrganic={editIngredientOrganicPrice} />
        
            <UnitList edit={edit} units={units} ingredient_id={props.obj.id} />
        </Container>


        </>
        
    );

}


const NameComponent = (props) => {
    const [name, setName] = useState(props.nameVal);
    const [edit, setEdit] = useState(props.edit)

    
    useEffect(() => {
        setName(props.nameVal);
        setEdit(props.edit)
    }, [props.edit, props.nameVal])

    const updateIngredient = (val) => {
        props.handleEdit(val)
    }
    
    if(edit) {
        return <input
        defaultValue={name}
        onChange={e => setName(e.target.value)}
        onBlur={e => updateIngredient(e.target.value)}
        />
    }

    return <p>{props.nameVal}</p>
}

const PriceComponent = (props) => {
    const [price, setPrice] = useState(props.price);
    const [organic, setOrganic] = useState(props.price_organic);
    
    const [edit, setEdit] = useState(props.edit)


    
    useEffect(() => {
        setPrice(props.price);
        setEdit(props.edit);
        setOrganic(props.price_organic);
    }, [props.edit, props.price, props.sale])

    
    if(edit) {
        return (
            <Row>
                <Col xs={6}>
                    <p>Normal pris:</p>
                    <input
                    defaultValue={price}
                    onChange={e => setPrice(e.target.value)}
                    onBlur={e => props.handlePrice(e.target.value)}
                    />
                </Col>
                <Col xs={6}>
                <p>Økologisk pris:</p>
                    <input
                    defaultValue={organic}
                    onChange={e => setOrganic(e.target.value)}
                    onBlur={e => props.handleOrganic(e.target.value)}
                    />
                </Col>
            </Row>
        )
    }
}


const UnitList = (props) => {
    //arr of unit ids
    const [units, setUnits] = useState(props.units);
    const [unitList, setUnitList] = useState([])
    useEffect(() => {
        if(!props.edit) {
            return;
        }

        if(props.obj.id === undefined) {
            console.log("err props obj is undefined still xdddd");
            console.log(props);

            return;
        }
        console.log("rec ing list");
        console.log(props);
        let isSubscribed = true;

        // declare the async data fetching function
        const fetchData = async () => {
          // get the data from the api
          
        
          const fetchUrl = api_url + "/api/recipes/unit";
          const data = await fetch(fetchUrl);
          const json = await data.json();

          //const data = [{name: "abc", id: 1, price:"12dkk",}, {name: "efg", id: 2, price:"12dkk"}, {name:param, id: 3, price:"14dkk"} ]
          // convert the data to json
          //const json = await response.json();
        
          // set state with the result if `isSubscribed` is true
          if (isSubscribed) {
            setUnitList(json);
            
            //todo: implementer enhedsnavn opslag + implementering af CRUD (backend er ordnet)
          }
        }
      
        // call the function
        fetchData()
          // make sure to catch any error
          .catch(console.error);;
      
        // cancel any future `setData`
        return () => isSubscribed = false;
      }, [props.edit])

      const addNewUnit = () => {
        setUnits([...units, {ingredient_id: props.ingredient_id}])
      }

    
    if(props.edit) {
        return (
            <Row className={"justify-content-center" + (props.edit ? "justify-content-center" : "justify-content-center d-none")}>
            <Col xs={10}>
                <Button onClick={addNewUnit}>Tilføj en ny enhed</Button>
            </Col>
            {units.length > 0 ? units.map((unit, i) => <UnitDisplay unitList={unitList} unit={unit} key={i} index={i}/>) : null}

        </Row>
        )
    }
}

const UnitDisplay = (props) => {
    const [unit, setUnit] = useState(props.unit);

    

    return (
        <>
            <Row>
                <Col xs={6}>
                    <p>:</p>
                    <input
                    onBlur={e => props.handlePrice(e.target.value)}
                    />
                </Col>
            </Row>
            </>


    );
}




export default IngredientDisplay;